import LoadingAnimationRoot, { Props } from './LoadingAnimation'

export default function LoadingAnimation(props: Props) {
  return <LoadingAnimationRoot {...props} />
}
